































































import moment from "moment/moment";
import { User } from "@/shared/User";
import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import MobileMixin from "@/mixins/mobileMixin";
import NavigationList from "@/layouts/navigationList.vue";
import ErrorMixin from "@/mixins/errorMixins";

@Component({
  components: { NavigationList },
})
export default class MyLayout extends mixins(MobileMixin, ErrorMixin) {
  public animate: boolean = true;

  public async mounted() {
    this.$store.dispatch("login/setLoading", true);
    if (!this.isMobile()) {
      this.load();
      this.stopLoading();
      this.$store.subscribe((mutation, getters) => {
        if (mutation.type.includes("LOADING")) {
          this.load();
        }
      });
    }
    // this.$store.dispatch("login/setLoading", false);
    const siteToken = moment.unix(localStorage.siteToken / 1000);
    const isAfter = moment().isAfter(siteToken, "d");
    // console.log(localStorage.sites, "is after" , isAfter, siteToken, moment().toDate());
    if (
      isAfter ||
      localStorage.sites === undefined ||
      localStorage.sites.length === 0 ||
      JSON.stringify(localStorage.sites) === "" ||
      JSON.stringify(localStorage.sites).includes("undefined")
    ) {
      if (!this.isMobile()) {
        this.$store.dispatch("login/setLoading", true);
        this.animate = true;
      }
      if (this.client !== "BK") {
        this.$store.dispatch("login/getEnseignes", true);
      }
      await this.$store
        .dispatch("login/getSites", this.client)
        .then((sites) => {
          // this.stopLoading();
        })
        .catch((error: any) => {
          console.log(error);
          this.stopLoading();
          this.setErrorFromTxt(this.$t("NoSites").toString());
          this.logout();
        });
    }

    this.stopLoading();
  }

  public load() {
    this.animate = true;
  }

  public end(evt: Event) {
    if (!this.loading) {
      this.animate = false;
    }
  }

  public goConfig() {
    this.$router.push("favoris");
  }

  // computed
  get user(): User {
    return this.$store.getters["login/user"];
  }

  get loading(): boolean {
    return this.$store.getters["login/loading"];
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }
}
